import React from "react";

const Progress = () => {
  return (
    <>
      <span className="tab-badge scheduled">in Progress</span>
    </>
  );
};
export default Progress;
